import { Link } from "react-router-dom";
import { Button } from "@themes/pollinator/ui/Button";
import { marketingNavigationItemsData } from "./marketingNavigationItems.data";
import { User } from "@platform/types/platform.types";
import { PlatformAvatarDropdown } from "@themes/pollinator/ui/PlatformAvatarDropdown";

export type Props = {
  onNavigationClick: (
    e: React.MouseEvent<HTMLAnchorElement>,
    to: string
  ) => void;
  onNavigationAnchorClick: (
    e: React.MouseEvent<HTMLAnchorElement>,
    hash: string
  ) => void;
  user: User | null;
  showLoginCta: boolean;
  menuItems: { title: string; href: string }[];
};

export function MarketingNavigationItems({
  onNavigationClick,
  onNavigationAnchorClick,
  user,
  showLoginCta,
  menuItems,
}: Props) {
  return (
    <>
      <nav className="flex flex-col w-full justify-start items-start gap-6 px-4 py-4 md:flex-row md:items-center md:justify-center md:gap-0 md:py-0 md:px-0">
        {marketingNavigationItemsData.map((item) => (
          <Button
            as="a"
            variant="ghost"
            data-testid={`marketing-nav-${item.title.toLowerCase()}`}
            href={item.href}
            key={item.title}
            onClick={(e: React.MouseEvent<HTMLAnchorElement>) =>
              onNavigationAnchorClick(e, item.href.split("#")[1])
            }
            title={item.title}
          >
            {item.title}
          </Button>
        ))}
      </nav>

      <div className="py-6 border-t border-brand-800 md:border-none">
        <div className="flex flex-col items-start gap-3 px-4 w-full md:flex-row md:items-center md:px-0 md:gap-2">
          {user ? (
            <PlatformAvatarDropdown
              photo={user.photo}
              fullName={user.first_name + " " + user.last_name}
              isLoaded={!!user}
              onNavigationClick={onNavigationClick}
              menuItems={menuItems}
            />
          ) : (
            <>
              {showLoginCta && (
                <Button
                  as={Link}
                  to="/login"
                  onClick={(e: React.MouseEvent<HTMLAnchorElement>) =>
                    onNavigationClick(e, "/login")
                  }
                  variant="primary"
                  className="md:size-max"
                  data-testid="marketing-nav-login"
                  title="Login"
                >
                  Login
                </Button>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default MarketingNavigationItems;

